import { scrollToTop } from "../lib/utilities";

class AjaxForm extends HTMLElement {

   form = null;
   errorNotification = null;
   sentMessage = null;

   connectedCallback() {
      this.form = document.createElement("form");
      while (this.children.length) {
         this.form.appendChild(this.children.item(0));
      }

      [
         "acceptCharset",
         "action",
         "elements",
         "encoding",
         "enctype",
         "length",
         "method",
         "name",
         "target",
      ].forEach(att => {
         if (this.hasAttribute(att)) {
            this.form.setAttribute(att, this.getAttribute(att));
            this.removeAttribute(att);
         }
      });

      this.appendChild(this.form);
      this.form.addEventListener("submit", this.submitHandler);
   }

   handleError(error) {
      scrollToTop();

      console.error(error);

      if (this.sentMessage && this.sentMessage.parentNode) {
         this.sentMessage.parentNode.removeChild(this.sentMessage);
      }

      if (!this.errorNotification) {
         this.errorNotification = document.createElement("div");
         this.errorNotification.className = "notification notification--error mb-3";
         this.errorNotification.innerText = "Beim Versenden des Formulars ist ein Fehler aufgetreten.";
         this.form.insertBefore(this.errorNotification, this.form.firstChild);
      }
   }

   handleResponse(response) {
      scrollToTop();

      if (response.success !== true) {
         return this.handleError(response.message);
      }

      if (this.errorNotification) {
         this.errorNotification.parentNode.removeChild(this.errorNotification);
      }

      if (!this.sentMessage) {
         this.sentMessage = document.createElement("div");

         const sentMessageHeadline = document.createElement("h3");
         sentMessageHeadline.className = "headline-4";
         sentMessageHeadline.innerText = "Vielen Dank!";
         this.sentMessage.appendChild(sentMessageHeadline);

         const sentMessageText = document.createElement("p");
         sentMessageText.className = "copy-1 mt-2";
         sentMessageText.innerText = "Wir werden uns in Kürze bei Ihnen melden.";
         this.sentMessage.appendChild(sentMessageText);

         this.innerHTML = "";
         this.appendChild(this.sentMessage);
      }
   }

   showLoadStart() {
      this.classList.add("is-loading");

      const submitButton = this.form.querySelector('[type="submit"]');
      if (submitButton) {
         submitButton.disabled = true;
      }
   }

   showLoadEnd() {
      this.classList.remove("is-loading");

      const submitButton = this.form.querySelector('[type="submit"]');
      if (submitButton) {
         submitButton.disabled = false;
      }
   }

   submitHandler = (event) => {
      event.preventDefault();

      this.showLoadStart();

      fetch(this.form.action, {
         method: "POST",
         body: new FormData(this.form),
         cache: "no-cache"
      })
         .then(response => response.json())
         .then(data => {
            this.showLoadEnd();
            this.handleResponse(data);
         })
         .catch(error => {
            this.showLoadEnd();
            this.handleError(error);
         });
   }

}

customElements.define('ajax-form', AjaxForm);
